import {
  Directions,
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@cp/components/TooltipV2/TooltipV2';
import InfoSolidSmallIcon from '@cp/src/assets/icons/InfoSolidSmallIcon';
import { Typography } from '@navi/web-ui/lib/primitives';

const DPDTooltipContent = () => {
  return (
    <Tooltip placement={Directions.TOP} hideStrategy="referenceHidden">
      <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
        <InfoSolidSmallIcon fill={'var(--navi-color-gray-c3)'} />
      </TooltipTrigger>
      <TooltipContent className={'tooltipWrapper px-2 py-1 !max-w-[250px]'}>
        <Typography variant="p4" color="var(--navi-color-gray-bg-primary)">
          {'The entered DPD ranges are inclusive of start and end values'}
        </Typography>
      </TooltipContent>
    </Tooltip>
  );
};

export default DPDTooltipContent;
